
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { TextArea } from '@drawbotics/react-drylus';
import { css } from '@emotion/css';
import Playground from '~/components/Playground';
import { ControlledField } from '../utils';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Text Area`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { TextArea } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ControlledField initialValue="" style={{ maxWidth: 250 }} component={
  <TextArea placeholder="Placeholder..." value="" />
} />`} component={TextArea} mdxType="Playground">
  <ControlledField initialValue="" style={{
        maxWidth: 250
      }} component={<TextArea placeholder="Placeholder..." value="" mdxType="TextArea" />} mdxType="ControlledField" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;